import classNames from "classnames";
import Styles from "./Duty.module.scss";
import Footer from "../../Component/Footer/Footer";
import Jumbotron from "../../Component/Jumbotron/Jumbotron";
import Navbar from "../../Component/Navbar/Navbar";

import img1 from "../../assets/images/index/社會責信.jpg";
import SubTitle from "../../Component/Text/SubTitle";
import CountUp from 'react-countup';
import { useInView } from "framer-motion";
import React from "react";

const SocialDuty = () => {
  const ref = React.useRef(null)
  const isInView = useInView(ref, { once: true });
  return (
    <div>
      <Navbar />
      {/* Jumbotron */}
      <div style={{ paddingTop: "8vh" }}>
        <Jumbotron img={img1} text={`社會責信`} />
      </div>
      <div className={classNames("container")}>
        <div className={classNames(Styles.duty__description)}>
          當我們走進社區，走進每一位長輩的生活裡，
          我們看見的不只是歲月的痕跡，更是每一段生命故事的溫度。長照，不只是照顧，更是陪伴，是在他們最需要的時候，伸出一雙溫柔的手。我們相信，每一份小小的關懷，都能為他們的日常，帶來一點光、一點暖。
          這，就是我們持續前行的理由。
        </div>
      </div>

      {/* ServiceCount */}
      <div className={classNames(Styles.duty__service)}>
        <SubTitle text={`服務人數`} />
        <div className={classNames("container")}>
          <div ref={ref}
            className={classNames(
              Styles.duty__service__card
            )}>
            <div

              className={classNames(
                "col-lg-6",
                "col-md-12",
                "col-sm-12",
                "mb-3",
              )}
            >
              <div>
                <div className={classNames(Styles.duty__service__card__title)}>
                  身心障礙者居家式
                  <br />
                  臨時短期照顧服務
                </div>
                <div

                  className={classNames(Styles.duty__service__card__content)}
                >
                  <p
                    className={classNames(
                      Styles.duty__service__card__content__num
                    )}
                  >
                    {isInView ? (
                      <CountUp start={0} end={1377} duration={2} separator="," />
                    ) : (
                      0
                    )}
                  </p>
                  <p
                    className={classNames(
                      Styles.duty__service__card__content__unit
                    )}
                  >
                    人
                  </p>
                </div>
                <div className={classNames(Styles.duty__service__card__param)}>
                  花蓮市、秀林鄉、吉安鄉、壽豐鄉、光復鄉、玉里鎮
                </div>
              </div>
            </div>
            <div
              className={classNames(
                "col-lg-6",
                "col-md-12",
                "col-sm-12",
                "mb-3",
              )}
            >
              <div>
                <div className={classNames(Styles.duty__service__card__title)}>
                  長期照顧巴士接送
                </div>
                <div
                  className={classNames(Styles.duty__service__card__content)}
                >
                  <p
                    className={classNames(
                      Styles.duty__service__card__content__num
                    )}
                  >
                    {isInView ? (
                      <CountUp start={0} end={3535} duration={2} separator="," />
                    ) : (
                      0
                    )}
                  </p>
                  <p
                    className={classNames(
                      Styles.duty__service__card__content__unit
                    )}
                  >
                    次
                  </p>
                </div>
                <div className={classNames(Styles.duty__service__card__param)}>
                  花蓮市、新城鄉、秀林鄉、吉安鄉、壽豐鄉、
                  <br />
                  瑞穗鄉、富里鄉、玉里鎮、卓溪鄉
                </div>
              </div>
            </div>
          </div>
          <div className={classNames(
            Styles.duty__service__card
          )}>
            <div
              className={classNames(
                "col-lg-6",
                "col-md-12",
                "col-sm-12",
                "mb-3",
              )}
            >
              <div>
                <div className={classNames(Styles.duty__service__card__title)}>
                  長照居家困境物資發放
                </div>
                <div
                  className={classNames(Styles.duty__service__card__content)}
                >
                  <p
                    className={classNames(
                      Styles.duty__service__card__content__num
                    )}
                  >
                    {isInView ? (
                      <CountUp start={0} end={41} duration={2} separator="," />
                    ) : (
                      0
                    )}
                  </p>
                  <p
                    className={classNames(
                      Styles.duty__service__card__content__unit
                    )}
                  >
                    人
                  </p>
                </div>
              </div>
            </div>
            <div className={classNames("col-6")}></div>
          </div>
          <div>
            <p className={classNames(Styles.duty__service__card__param)}>
              資料來源：112年廣博長照慈善協會
            </p>
          </div>
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default SocialDuty;
